/** Shell 본문 폭 tier — pathname prefix 매칭 */

export const SHELL_LAYOUT_TIERS = {
  DEFAULT: 'default',
  WIDE: 'wide',
  FULL: 'full',
}

/** 테이블·CRM 등 가로 공간이 필요한 화면 */
const WIDE_PATH_PREFIXES = [
  '/',
  '/menu-overview',
  '/support/customers',
  '/support/maturity-ledger',
  '/support/claims',
  '/health-analysis',
  '/hidden-insurance-money',
  '/health/disease-stats',
  '/fire/building-registry',
  '/work/calendar',
  '/work/insurance-market-insights',
  '/work/policy-lookup',
  '/work/personal-tasks',
  '/work/insurer-systems',
  '/design',
  '/data/insurers',
  '/data/terms',
  '/files',
  '/requests',
  '/sales/public-landing',
  '/sales/org-homepage',
  '/work/education',
  '/support/inquiries',
  '/withdrawal-approvals',
  '/ops',
  '/subscriptions',
]

export function resolveShellLayoutTier(pathname) {
  const path = pathname || '/'
  if (WIDE_PATH_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`))) {
    return SHELL_LAYOUT_TIERS.WIDE
  }
  return SHELL_LAYOUT_TIERS.DEFAULT
}

export function shellMainContentClass(tier) {
  switch (tier) {
    case SHELL_LAYOUT_TIERS.WIDE:
    case SHELL_LAYOUT_TIERS.FULL:
      return 'w-full max-w-none'
    default:
      return 'mx-auto w-full max-w-6xl'
  }
}
